export default {
  inspectionLevel: (state) => {
    return state.inspectionLevel;
  },
  inspectionLevelCode: (state) => {
    return state.inspectionLevelCode;
  },

  productionGroups: (state) => {
    return state.productionGroups;
  },
  productionGroup: (state) => {
    return state.productionGroup;
  },
  productionGroupsCode: (state) => {
    return state.productionGroupsCode;
  },

  productionGroupSupplier: (state) => {
    return state.productionGroupSupplier;
  },
  productionGroupSupplierCode: (state) => {
    return state.productionGroupSupplierCode;
  },

  purchaseContracts: (state) => {
    return state.purchaseContracts;
  },
  purchaseContractsCode: (state) => {
    return state.purchaseContractsCode;
  },

  saleTypes: (state) => {
    return state.saleTypes;
  },
  saleTypesCode: (state) => {
    return state.saleTypesCode;
  },

  stopStations: (state) => {
    return state.stopStations;
  },
  stopStationsCode: (state) => {
    return state.stopStationsCode;
  },

  orders: (state) => {
    return state.orders;
  },
  order: (state) => {
    return state.order;
  },
  ordersCode: (state) => {
    return state.ordersCode;
  },
  orderCommodityAttachment: (state) => {
    return state.orderCommodityAttachment;
  },

  orderDataSheets: (state) => {
    return state.orderDataSheets;
  },
  orderDataSheet: (state) => {
    return state.orderDataSheet;
  },
  orderDataSheetCode: (state) => {
    return state.orderDataSheetCode;
  },

  settings: (state) => {
    return state.settings;
  },

  technicalCartable: (state) => {
    return state.technicalCartable;
  },

  mapConfirmCartable: (state) => {
    return state.mapConfirmCartable;
  },

  inventoryControlCartable: (state) => {
    return state.inventoryControlCartable;
  },

  deliveryDateCartable: (state) => {
    return state.deliveryDateCartable;
  },

  confirmDeliveryDateCartable: (state) => {
    return state.confirmDeliveryDateCartable;
  },

  isNeedPlanCartable: (state) => {
    return state.isNeedPlanCartable;
  },

  sellCartable: (state) => {
    return state.sellCartable;
  },

  commodityAdditionalInfo: (state) => {
    return state.commodityAdditionalInfo;
  },

  bomCommodities: (state) => {
    return state.bomCommodities;
  },
  boms: (state) => {
    return state.boms;
  },

  orderCommodityReservation: (state) => {
    return state.orderCommodityReservation;
  },

  commodityInventoryWare: (state) => {
    return state.commodityInventoryWare;
  },

  orderCommodityStatusLogs: (state) => {
    return state.orderCommodityStatusLogs;
  },

  modiranMappings: (state) => {
    return state.modiranMappings;
  },

  modiranSideWares: (state) => {
    return state.modiranSideWares;
  },

  modiranSideVoucherTypes: (state) => {
    return state.modiranSideVoucherTypes;
  },

  modiranSideLoading: (state) => {
    return state.modiranSideLoading;
  },

  modiranSideError: (state) => {
    return state.modiranSideError;
  },
};
